// R1 — Monthly Scorecard (Cockpit). Data from GET /v1/bo/scorecard (see
// backoffice.routes.js -> models.scorecard.getScorecard), which reuses churn_cohort
// (P1a) and churn_activity_log_monthly (P1b) rather than recomputing churn/engagement
// independently. Read-only: numbers come from bot_scorecard.js /
// POST /v1/bo/scorecard/recompute; targets are set in the separate
// "Target Scorecard" screen.
const RUPIAH_METRICS = new Set(["mrr", "arpu_riil", "kas_collected"]);
const PERCENT_METRICS = new Set(["churn_rate_monthly", "renewal_rate_monthly", "engagement_pct"]);

const formatValue = (metricKey, value) => {
  if (value == null) return "-";
  if (RUPIAH_METRICS.has(metricKey)) {
    return `Rp${Number(value).toLocaleString("id-ID", { maximumFractionDigits: 0 })}`;
  }
  if (PERCENT_METRICS.has(metricKey)) {
    return `${value}%`;
  }
  return Number(value).toLocaleString("id-ID");
};

const STATUS_ICON = { hijau: "🟢", kuning: "🟡", merah: "🔴" };

let churnScorecardSection = {
  name: "Monthly Scorecard",
  slug: "churnScorecard",
  visible: true,
  singularName: "churnScorecard",
  crud: true,
  endpoint: "/v1/bo/scorecard",
  updateLabel: "churnScorecard",
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  noNeedSearch: true,
  noNeedRefresh: false,
  add: false,
  update: false,
  edit: false,
  exportToCsv: true,
  fields: [
    {
      label: "Metrik",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.label ? row.label : "-"),
    },
    {
      label: "Bulan Lalu",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => formatValue(row.metric_key, row.bulan_lalu),
    },
    {
      label: "Bulan Ini",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => formatValue(row.metric_key, row.bulan_ini),
    },
    {
      label: "Target",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.target != null ? formatValue(row.metric_key, row.target) : "Belum diset"),
    },
    {
      label: "Status",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.status ? `${STATUS_ICON[row.status] || ""} ${row.status}` : "-"),
    },
  ],
};

export default [churnScorecardSection];
